import { useTranslation } from 'react-i18next';
import { Box, Button } from '@mui/material';

const Footer = ({ onClear, hasCompletedTasks }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{
      p: 2,
      borderTop: 1,
      borderColor: 'divider',
      display: 'flex',
      justifyContent: 'flex-end',
    }}
    >
      <Button
        onClick={onClear}
        disabled={!hasCompletedTasks}
        variant="outlined"
        size="small"
      >
        {t('Btn_ClearAll')}
      </Button>
    </Box>
  );
};

export default Footer;
